<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
            <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Usuarios</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <Loading v-if="isLoading"/>
                      <tr v-for="(user, index) in users" :key="index">
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            
                            <a class="btn bg-danger mx-1 text-white" :href="'/user/'+user._id"><i class="fa fa-pencil"></i></a>
                            <a class="btn bg-danger mx-1 text-white" @click="sendCrendentials(user._id)"><i class="fa fa-envelope-o"></i></a>
                          </div>
                        </td>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Email:</p>
                              <h6 class="mb-0 text-sm"><a :href="'/user/'+user._id">{{ user.Email }}</a></h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Usuario:</p>
                            <h6 class="mb-0 text-sm">{{ user.Name }}</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Tipo:</p>
                            <h6 class="mb-0 text-sm" v-if="user.Type =='Customer'">Cliente</h6>
                            <h6 class="mb-0 text-sm" v-if="user.Type =='Salesforce'">Ejecutivo</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Estado:</p>
                            <h6 class="mb-0 text-sm" v-if="user.Estado__c !=null">{{ user.Estado__c}}</h6>
                          </div>
                        </td>
                        
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="!hasUsers && !isLoading" class="text-center">
                  <img :src="folder" style="max-width: 20%;"/> 
                  <h4>No se encontraron registros</h4>
                </div>
            </div>
        </div>
      </div>
      
    </div>
  </template>
  
<script>
  import Loading from '../../examples/Loading.vue';
  import moment from 'moment';
  import folder from "@/assets/img/folder.png";
  import axios from 'axios';
  export default {
    name: "tables",
    components: {
      Loading,
    },
    data() {
      return {
        folder,
        users: [],
        isLoading:false,
        hasUsers:false
      };
    },
    methods:{
      async fetchInstalls(){
        this.isLoading=true;
        fetch(this.$EndPoint+'users/')
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.users=result;
          if(this.users.length>0){
            this.hasUsers=true;
          }else{
            this.hasUsers=false;
          }
          this.isLoading=false;
        })
      },
      sendCrendentials(id){
        axios.get(this.$EndPoint+'users/mail-user/'+id)
        .then(result=>{
            console.log(result);
            this.$swal({
                title: 'Correo enviado',
                icon:'success',
                color:'#b4243a',
                confirmButtonText:'Aceptar',
                buttonsStyling:false,
                customClass:{
                    confirmButton:'btn btn-danger'
                },
                confirmButtonColor:'#b4243a',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
                })
        });
      },
      getFormattedDate(date) {
        return moment(date).format("YYYY-MM-DD")
      }
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchInstalls();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>
  